<template>
    <nav ref="navbar" :class="['navbar', { hidden: isHidden, show: isShown }]">
      <div class="bg"></div>
      <div class="navbar-max-width">
        <div class="row row-no-margin">
          <div class="col col-1 col-spacer"></div>
          <div class="col col-11">
            <ul>
              <li v-for="section in sections" :key="section.id">
                <a
                  :href="`#${section.id}`"
                  @click.prevent="scrollTo(section.id)"
                  :class="{ active: currentSection === section.id }"
                >
                  {{ section.label }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  </template>
  
  <script>

  export default {
    name: "StickyNavbar",
    data() {
      return {
        lastScrollY: 0,
        isHidden: false,
        isShown: false,
        hideTimeout: null,
        navbarOffset: 0, // replaces heroHeight
        currentSection: null,
        sections: [
          { id: "preface", label: "Preface" },
          { id: "origin", label: "Origin" },
          { id: "atm", label: "ATM" },
          { id: "network", label: "Network" },
          { id: "complementary", label: "Complementary" }
        ],
        observer: null
      };
    },
    methods: {
      scrollTo(targetId) {
        const element = document.getElementById(targetId);
        if (!element) return;
        const startY = window.scrollY;
        const targetY = element.getBoundingClientRect().top + startY;
        const diff = targetY - startY;
        const duration = 1500; // duration in ms
        let startTime = null;
  
        const easeInOutQuad = t =>
          t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  
        const animate = currentTime => {
          if (!startTime) startTime = currentTime;
          const elapsed = currentTime - startTime;
          let progress = Math.min(elapsed / duration, 1);
          progress = easeInOutQuad(progress);
          window.scrollTo(0, startY + diff * progress);
          if (elapsed < duration) {
            requestAnimationFrame(animate);
          }
        };
  
        requestAnimationFrame(animate);
      },
      handleScroll() {
        const currentY = window.scrollY;
        // Use navbarOffset instead of heroHeight
        if (currentY < this.navbarOffset) {
          this.isHidden = false;
        } else {
          this.isHidden = currentY > this.lastScrollY;
        }
        this.lastScrollY = currentY;
  
        // Determine the current section based on the viewport's vertical midpoint
        // const viewportMiddle = window.innerHeight / 2;
        // this.sections.forEach(section => {
        //   const element = document.getElementById(`${section.id}-section`);
        //   console.log('[handleScroll] element', element);
        //   if (element) {
        //     const rect = element.getBoundingClientRect();
        //     if (rect.top <= viewportMiddle && rect.bottom >= viewportMiddle) {
        //       this.currentSection = section.id;
        //       console.log('[currentSection]', this.currentSection);
        //     }
        //   }
        // });

        // Determine the active section based on the viewport's vertical midpoint.
        const viewportMiddle = window.innerHeight / 2;
        let active = null;
        this.sections.forEach(section => {
            const element = document.getElementById(`${section.id}-section`);
            if (element) {
            const rect = element.getBoundingClientRect();
            if (rect.top <= viewportMiddle && rect.bottom >= viewportMiddle) {
                active = section.id;
            }
            }
        });
        this.currentSection = active;
      },
      setupObserver() {
        const options = { threshold: 0.5 };
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.isHidden = false;
              clearTimeout(this.hideTimeout);
              this.hideTimeout = setTimeout(() => {
                if (window.scrollY > this.navbarOffset) {
                  this.isHidden = true;
                }
              }, 1500);
            }
          });
        }, options);
        document.querySelectorAll("section").forEach(section =>
          this.observer.observe(section)
        );
      }
    },
    mounted() {
    setTimeout(() => {
        this.isShown = true;
    }, 10);

      this.lastScrollY = window.scrollY;
      // Set navbarOffset from the navbar's original position plus its height
      this.navbarOffset =
        this.$refs.navbar.offsetTop + this.$refs.navbar.offsetHeight;
      console.log('[navbarOffset]', this.navbarOffset);
      window.addEventListener("scroll", this.handleScroll);
      this.setupObserver();
    },
    beforeUnmount() {
      window.removeEventListener("scroll", this.handleScroll);
      if (this.observer) this.observer.disconnect();
      clearTimeout(this.hideTimeout);
    }
  };
  </script>
  
  <style scoped>
  .navbar {
    position: sticky;
    top: 0;
    z-index: 10000;
    transition: transform 0.3s ease-in-out;
  }
  .navbar .bg {
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #222222;
  }
  .hidden {
    transform: translateY(-100%);
  }
  .navbar ul {
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;
  }
  .navbar li {
    margin: 0;
    margin-right: 1.6rem;
    padding: 1.6rem 0;
  }
  .navbar a {
    color: #7E7E7E;
    text-decoration: none;
    font-size: 1.6rem;
    font-weight: 500;
    font-family: "Untitled Sans", sans-serif;
    line-height: 1;
    letter-spacing: -0.03em;
    transition: all 200ms ease-in-out;
  }
  .navbar a:hover {
    color: #fff;
    cursor: pointer;
  }
  .navbar a.active {
    color: #fff; /* Active link color */
  }
  .navbar-max-width {
    max-width: var(--max-width);
    margin: 0 auto;
  }
  .navbar .col {
    padding-top: 0;
    padding-bottom: 0;
  }

  /* animations */

  .navbar ul {
    opacity: 0;
    transform: translateY(5px);
    transition: all 250ms cubic-bezier(0.42, 0, 0.11, 1.02);
    transition-delay: 150ms;
  }

  .navbar.show ul {
    opacity: 1;
    transform: translateX(0);
  }

  .navbar .bg {
    transform: scaleY(0);
    transform-origin: top;
    transition: all 175ms cubic-bezier(0.42, 0, 0.11, 1.02);
  }

  .navbar.show .bg {
    transform: scaleY(1);
  }

  /* .navbar li {
    opacity: 0;
    transform: translateX(-3px);
    transition: all 150ms cubic-bezier(0.42, 0, 0.11, 1.02);
  }

  .navbar.show li {
    opacity: 1;
    transform: translateX(0);
  }

  .navbar li:nth-child(1) {
    transition-delay: 50ms;
  }
  .navbar li:nth-child(2) {
    transition-delay: 100ms;
  }
  .navbar li:nth-child(3) {
    transition-delay: 150ms;
  }
  .navbar li:nth-child(4) {
    transition-delay: 200ms;
  }
  .navbar li:nth-child(5) {
    transition-delay: 250ms;
  } */



  @media (max-width: 768px) {
    .navbar a {
        font-size: 1.45rem;
    }
    .navbar-max-width {
        max-width: 90vw;
    }

    .navbar .col {
        padding-left: 0;
        padding-right: 0;
    }

    .navbar a:hover {
        color: #7E7E7E;
    }

    .navbar a.active:hover {
        color: #fff;
    }
  }
  </style>
  